import {useQuery} from "@tanstack/react-query";
import {useMemo} from "react";
import {adaptNotificationsFeed} from "../../adapters/notification.adapter";
import {getNewsService} from "../../services/News/news.service";
import {getNotificationService} from "../../services/notifications/getNotifications";
import {useAuthStore} from "../../store/useAuth.store";

const FEED_LIMIT = 10;

const useNotificationsFeed = () => {
  const authStatus = useAuthStore(state => state.authStatus);

  const pushQuery = useQuery({
    queryKey: ["listNotifications"],
    queryFn: getNotificationService,
    staleTime: 5 * 60 * 1000,
    refetchInterval: authStatus === "authenticated" ? 60 * 1000 : false,
    enabled: authStatus === "authenticated",
  });

  const newsQuery = useQuery({
    queryKey: ["News", {limit: FEED_LIMIT}],
    queryFn: () => getNewsService({limit: FEED_LIMIT}),
    staleTime: 10 * 60 * 1000,
  });

  const pushNotifications = pushQuery.data?.data?.data ?? [];
  const newsArticles = newsQuery.data?.data?.data?.articles ?? [];

  const feed = useMemo(
    () => adaptNotificationsFeed(pushNotifications, newsArticles),
    [pushNotifications, newsArticles]
  );

  const unreadCount = useMemo(() => feed.filter(item => !item.isRead).length, [feed]);

  return {
    feed,
    unreadCount,
    isLoading: pushQuery.isLoading || newsQuery.isLoading,
    isError: pushQuery.isError && newsQuery.isError,
    refetch: () => {
      pushQuery.refetch();
      newsQuery.refetch();
    },
  };
};

export default useNotificationsFeed;
